import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const MapMark: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.7034 13.1692C18.3335 12.1359 18.7535 10.8852 18.7535 9.58005C18.7535 5.93654 15.9183 3 12.4005 3C8.88281 3 6.04761 5.93654 6.04761 9.58005C6.04761 10.9396 6.41513 12.1359 7.09768 13.1692C7.15018 13.2779 7.2027 13.3323 7.2552 13.4411L12.4005 21L17.5459 13.4411C17.5984 13.3323 17.6509 13.2779 17.7034 13.1692Z"
        stroke="#07404E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4005 12.5295C13.8624 12.5295 15.0475 11.3443 15.0475 9.8824C15.0475 8.42047 13.8624 7.23535 12.4005 7.23535C10.9385 7.23535 9.75342 8.42047 9.75342 9.8824C9.75342 11.3443 10.9385 12.5295 12.4005 12.5295Z"
        stroke="#07404E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { MapMark };
